import { render, staticRenderFns } from "./TicketDots.vue?vue&type=template&id=385c00d9&scoped=true"
import script from "./TicketDots.vue?vue&type=script&lang=js"
export * from "./TicketDots.vue?vue&type=script&lang=js"
import style0 from "./TicketDots.vue?vue&type=style&index=0&id=385c00d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c00d9",
  null
  
)

export default component.exports